export const LOGIN = 'LOGIN'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR'

export const IS_USER_AUTHENTICATED = 'IS_USER_AUTHENTICATED'
export const PROGRAM_ACTIVE_STATE = 'PROGRAM_ACTIVE_STATE'
export const PROGRAM_CONFIG_ACTIVE_STATE = 'PROGRAM_CONFIG_ACTIVE_STATE'
export const ON_LOGOUT = 'ON_LOGOUT'
export const ON_MANUAL_LOGOUT = 'ON_MANUAL_LOGOUT'

export const USER_ROLES = 'USER_ROLES'
export const USER_RIGHT_OBJECTS = 'USER_RIGHT_OBJECTS'
export const USER_RIGHTS = 'USER_RIGHTS'
export const ASSETS_TYPE_COUNT_SUCCESS = "ASSETS_TYPE_COUNT_SUCCESS"
export const ASSETS_TYPE_COUNT_ERROR = "ASSETS_TYPE_COUNT_ERROR"

export const RESET_ALL_STATE = 'RESET_ALL_STATE';
export const SET_ROLES_DATA = 'SET_ROLES_DATA'
export const SET_ROLE_IDS = 'SET_ROLE_IDS'
export const SET_RIGHT_OBJECTS = 'SET_RIGHT_OBJECTS'
export const SET_ROLE_RIGHTS = 'SET_ROLE_RIGHTS'
export const ROLES_ERROR = 'ROLES_ERROR'
export const ROLES_INFO_COUNT_SUCCESS = 'ROLES_INFO_COUNT_SUCCESS'


export const SHOW_DATA = 'SHOW_DATA'
export const UPDATE_USER = 'UPDATE_USER'


export const PORTAL_PREFIX = 'PORTAL_'

/* ProcessList Types */
export const IS_PROCESS_LOADING = 'IS_PROCESS_LOADING'
export const SET_PROCESS_LIST = 'SET_PROCESS_LIST'
export const PROCESS_LIST_ERROR = 'PROCESS_LIST_ERROR'

export const PROGRAM_DETAIL = 'PROGRAM_DETAIL'
export const SET_PORTAL_LIST_ITEM_LOGO = 'SET_PORTAL_LIST_ITEM_LOGO'
export const PROGRAM_DETAIL_SUCCESS = 'PROGRAM_DETAIL_SUCCESS'
export const COUNT_PROGRAMS_SUCCESS = 'COUNT_PROGRAMS_SUCCESS'
export const PROGRAM_ADD_SUCCESS = 'PROGRAM_ADD_SUCCESS'
export const PROGRAM_DETAIL_ERROR = 'PROGRAM_DETAIL_ERROR'
export const PROGRAM_LIST_ERROR = 'PROGRAM_LIST_ERROR'
export const ALL_PROGRAMS_LIST = 'ALL_PROGRAMS_LIST'
export const GET_PROGRAM_ERROR = 'GET_PROGRAM_ERROR'
export const PROGRAMS_DATA = 'PROGRAMS_DATA'
export const PROGRAM_DETAILS_ERROR = 'PROGRAM_DETAILS_ERROR'
export const SELECTED_PROGRAM_DATA = 'SELECTED_PROGRAM_DATA'
export const SET_PORTAL_LOGO = 'SET_PORTAL_LOGO'
export const SET_PORTAL_LOGO_NAME = 'SET_PORTAL_LOGO_NAME'
export const PROCESS_DETAIL_ERROR = 'PROCESS_DETAIL_ERROR'
export const PROCESS_DETAIL_DATA = 'PROCESS_DETAIL_DATA'
export const PROCESS_ASSETS_DATA = 'PROCESS_ASSETS_DATA'
export const PROCESS_EXCEL_ASSETS_DATA = 'PROCESS_EXCEL_ASSETS_DATA'
export const PROCESS_DETAIL_UPDATE = "PROCESS_DETAIL_UPDATE"
export const UPDATED_REQUEST_PROGRESS_DATA = "UPDATED_REQUEST_PROGRESS_DATA"
export const PROGRAM_ADDING = 'PROGRAM_ADDING'
export const PROGRAM_COPY_SUCCESS = 'PROGRAM_COPY_SUCCESS'
export const PROGRAM_MESSAGE = 'PROGRAM_MESSAGE'
export const CLEAR_PROGRAM_MESSAGE = 'CLEAR_PROGRAM_MESSAGE'
export const PROGRAM_IP_WHITELIST_ROUTES = 'PROGRAM_IP_WHITELIST_ROUTES'

/* Request Statues List */
export const REQUEST_STATUSES_ERROR = 'REQUEST_STATUSES_ERROR'
export const REQUEST_STATUSES_LIST = 'REQUEST_STATUSES_LIST'
export const REQUEST_STATUSES_PROGRESS = 'REQUEST_STATUSES_PROGRESS'
export const SET_REQUEST_REJECTED = 'SET_REQUEST_REJECTED'
export const SELECTED_REQUEST_STATUS_SEQUENCE = 'SELECTED_REQUEST_STATUS_SEQUENCE'


/* Create New Program */
export const SET_PROGRAM_CLIENTID = 'SET_PROGRAM_CLIENTID'
export const UPDATE_PROGRAM_DETAILS = 'UPDATE_PROGRAM_DETAILS'
export const SET_PROGRAM_COUNTRYID = 'SET_PROGRAM_COUNTRYID'
export const SET_ALL_COUNTRIES = 'SET_ALL_COUNTRIES'

/* Clients Data Data  */
export const SELECTED_CLIENT_DATA = "SELECTED_CLIENT_DATA"
export const SET_ALL_CLIENTS = 'SET_ALL_CLIENTS'
export const ALL_CLIENTS_ERROR = 'ALL_CLIENTS_ERROR'
export const CLIENT_LIST_OF_USER = 'CLIENT_LIST_OF_USER'
export const LIST_ALL_CLIENTS = 'LIST_ALL_CLIENTS'
export const CLIENT_ERROR = "CLIENT_ERROR"
export const CLIENT_ADDED = "CLIENT_ADDED"
export const CLIENT_ADDED_SUCCESS = "CLIENT_ADDED_SUCCESS"
export const CLIENT_COPY_SUCCESS = "CLIENT_COPY_SUCCESS"
// export const CLIENT_DESTROY_SUCCESS = "CLIENT_DESTROY_SUCCESS"
export const CLIENT_ADDING = "CLIENT_ADDING"
export const CLEAR_CLIENT_MESSAGE = "CLEAR_CLIENT_MESSAGE"

export const CLIENT_UPDATE = "CLIENT_UPDATE"
export const CLIENT_UPDATE_SUCCESS = "CLIENT_UPDATE_SUCCESS"


export const CLIENT_DELETED = "CLIENT_DELETED"
export const CLIENT_DELETED_SUCCESS = "CLIENT_DELETED_SUCCESS"


export const SET_ALL_CLIENT_LANGUAGE = "SET_ALL_CLIENT_LANGUAGE"
export const SET_ALL_CLIENT_PACKINGS = "SET_ALL_CLIENT_PACKINGS"
export const SET_ALL_CLIENT_PACKINGS_COUNT = "SET_ALL_CLIENT_PACKINGS_COUNT"


export const CLIENT_PACKING_ADDED = "CLIENT_PACKING_ADDED"
export const CLIENT_PACKING_ADDED_SUCCESS = "CLIENT_PACKING_ADDED_SUCCESS"


export const CLIENT_PACKING_DELETED = "CLIENT_PACKING_DELETED"
export const CLIENT_PACKING_DELETED_SUCCESS = "CLIENT_PACKING_DELETED_SUCCESS"

export const CLIENT_PROCESSING_PARTNERS_LIST = "CLIENT_PROCESSING_PARTNERS_LIST"
export const CLIENT_PROCESSING_PARTNERS_LIST_COUNT = "CLIENT_PROCESSING_PARTNERS_LIST_COUNT"

export const CLIENT_PARTNER_ADDED = "CLIENT_PARTNER_ADDED"
export const CLIENT_PARTNER_ADDED_SUCCESS = "CLIENT_PARTNER_ADDED_SUCCESS"


export const CLIENT_PARTNER_DELETED = "CLIENT_PARTNER_DELETED"
export const CLIENT_PARTNER_DELETED_SUCCESS = "CLIENT_PARTNER_DELETED_SUCCESS"
export const CLIENT_ASSETS_LIST = "CLIENT_ASSETS_LIST"
export const CLIENT_ASSETS_LIST_COUNT = "CLIENT_ASSETS_LIST_COUNT"

export const SET_ADDRESS_COLLECTIONS = "SET_ADDRESS_COLLECTIONS"
export const ADD_ADDRESS_COLLECTION_SUCCESS = "ADD_ADDRESS_COLLECTION_SUCCESS"
export const ADD_ADDRESS_COLLECTION_ERROR = "ADD_ADDRESS_COLLECTION_ERROR"
export const DELETE_ADDRESS_COLLECTION_SUCCESS = "DELETE_ADDRESS_COLLECTION_SUCCESS"
export const DELETE_ADDRESS_COLLECTION_ERROR = "DELETE_ADDRESS_COLLECTION_ERROR"

export const CLIENT_ASSETS_ADDED = "CLIENT_ASSETS_ADDED"
export const CLIENT_ASSETS_ADDED_SUCCESS = "CLIENT_ASSETS_ADDED_SUCCESS"
export const CLIENT_ASSETS_ADDED_ERROR = "CLIENT_ASSETS_ADDED_ERROR"

export const CLIENT_ASSETS_DELETED = "CLIENT_ASSETS_DELETED"
export const CLIENT_ASSETS_DELETED_SUCCESS = "CLIENT_ASSETS_DELETED_SUCCESS"
export const CLIENT_ASSETS_DELETED_ERROR = "CLIENT_ASSETS_DELETED_ERROR"


export const CLIENT_TERMS_SUCCESS = "CLIENT_TERMS_SUCCESS"
export const CLIENT_TERMS_ERROR = "CLIENT_TERMS_ERROR"
export const CLIENT_TERMS_ADDED = "CLIENT_TERMS_ADDED"
export const CLIENT_TERMS_ADDED_SUCCESS = "CLIENT_TERMS_ADDED_SUCCESS"
export const CLIENT_TERMS_ADDED_ERROR = "CLIENT_TERMS_ADDED_ERROR"
export const CLIENT_PRIVACY_ADDED = "CLIENT_PRIVACY_ADDED"
export const CLIENT_PRIVACY_ADDED_SUCCESS = "CLIENT_PRIVACY_ADDED_SUCCESS"
export const CLIENT_PRIVACY_ADDED_ERROR = "CLIENT_PRIVACY_ADDED_ERROR"

export const CLIENT_TERMS_UPDATE_SUCCESS = "CLIENT_TERMS_UPDATE_SUCCESS"
export const CLIENT_PRIVACY_UPDATE_SUCCESS = "CLIENT_PRIVACY_UPDATE_SUCCESS"

export const GET_CLIENT_SERVICES = "GET_CLIENT_SERVICES"
export const GET_CLIENT_SERVICES_COUNT = "GET_CLIENT_SERVICES_COUNT"
export const CLIENT_SERVICES_ADDED = "CLIENT_SERVICES_ADDED"
export const CLIENT_SERVICES_ADDED_ERROR = "CLIENT_SERVICES_ADDED_ERROR"
export const CLIENT_SERVICES_UPDATE_SUCCESS = "CLIENT_SERVICES_UPDATE_SUCCESS"
export const CLIENT_SERVICES_UPDATE_ERROR = "CLIENT_SERVICES_UPDATE_ERROR"
export const CLIENT_SERVICES_DELETE_SUCCESS = "CLIENT_SERVICES_DELETE_SUCCESS"
export const CLIENT_SERVICES_DELETE_ERROR = "CLIENT_SERVICES_DELETE_ERROR"


/** Client PO */
export const GET_CLIENT_PO = "GET_CLIENT_PO"
export const GET_CLIENT_PO_COUNT = "GET_CLIENT_PO_COUNT"
export const CLIENT_PO_ADD_SUCCESS = "CLIENT_PO_ADD_SUCCESS"
export const CLIENT_PO_DELETE_SUCCESS = "CLIENT_PO_DELETE_SUCCESS"
export const CLIENT_PO_UPDATE = "CLIENT_PO_UPDATE"

/*LANGUAGES ADDED*/
export const CULTURES_DETAIL_SUCCESS = 'CULTURES_DETAIL_SUCCESS'
export const CULTURES_DETAIL_ERROR = 'CULTURES_DETAIL_ERROR'
export const CLIENT_CULTURES_ADDED_SUCCESS = "CLIENT_CULTURES_ADDED_SUCCESS"

export const CULTURES_ADDED_SUCCESS = 'CULTURES_ADDED_SUCCESS'

export const CULTURES_DELETED_SUCCESS = 'CULTURES_DELETED_SUCCESS'
export const LIST_CULTURES_LIST = 'LIST_CULTURES_LIST'

export const UPDATED_CULTURES_DATA = 'UPDATED_CULTURES_DATA'
export const CULTURES_DEFAULT_SUCCESS = "CULTURES_DEFAULT_SUCCESS"
export const CULTURE_INFO_COUNT_SUCCESS = "CULTURE_INFO_COUNT_SUCCESS"
/*LABELS ADDED*/

export const LABELS_DETAIL_SUCCESS = 'LABELS_DETAIL_SUCCESS'
export const LABELS_ADDED_SUCCESS = 'LABELS_ADDED_SUCCESS'
export const LABELS_DELETED_SUCCESS = 'LABELS_DELETED_SUCCESS'
export const LIST_ALL_LABELS = 'LIST_ALL_LABELS'
export const LABELS_ERROR = 'LABELS_ERROR'
export const LABELS_UPDATED_SUCCESS = "LABELS_UPDATED_SUCCESS"
export const LABEL_INFO_COUNT_SUCCESS = "LABEL_INFO_COUNT_SUCCESS"

/*BOXES ADDED*/

export const BOXES_DETAIL_SUCCESS = 'BOXES_DETAIL_SUCCESS'
export const BOXES_ADDED_SUCCESS = 'BOXES_ADDED_SUCCESS'
export const BOXES_DELETED_SUCCESS = 'BOXES_DELETED_SUCCESS'
export const LIST_ALL_BOXES = 'LIST_ALL_BOXES'
export const BOXES_ERROR = 'BOXES_ERROR'
export const BOXES_UPDATED_SUCCESS = "BOXES_UPDATED_SUCCESS"
export const BOX_INFO_COUNT_SUCCESS = "BOX_INFO_COUNT_SUCCESS"

/*TRUCK LIST */

export const TRUCK_DETAIL_SUCCESS = 'TRUCK_DETAIL_SUCCESS'
export const TRUCKS_ADDED_SUCCESS = 'TRUCKS_ADDED_SUCCESS'
export const TRUCK_DELETED_SUCCESS = 'TRUCK_DELETED_SUCCESS'
export const LIST_ALL_TRUCKS = 'LIST_ALL_TRUCKS'
export const TRUCK_ERROR = 'TRUCK_ERROR'
export const TRUCK_LIST_UPDATED_SUCCESS = "TRUCK_LIST_UPDATED_SUCCESS"
export const TRUCK_INFO_COUNT_SUCCESS = "TRUCK_INFO_COUNT_SUCCESS"

/*CURRENCIES LIST*/
export const CURRENCIES_DETAIL_SUCCESS = 'CURRENCIES_DETAIL_SUCCESS'
export const CURRENCIES_ADDED_SUCCESS = 'CURRENCIES_ADDED_SUCCESS'
export const CURRENCIES_DELETED_SUCCESS = 'CURRENCIES_DELETED_SUCCESS'
export const LIST_ALL_CURRENCIES = 'LIST_ALL_CURRENCIES'
export const CURRENCIES_UPDATED_SUCCESS = "CURRENCIES_UPDATED_SUCCESS"
export const CURRENCY_ERROR = 'CURRENCY_ERROR'
export const CURRENCY_INFO_COUNT_SUCCESS = 'CURRENCY_INFO_COUNT_SUCCESS'
export const CURRENCY_UPLOAD_SUCCESS = 'CURRENCY_UPLOAD_SUCCESS'

/*REGIONS LIST*/
export const REGIONS_DETAIL_SUCCESS = 'REGIONS_DETAIL_SUCCESS'
export const REGIONS_ADDED_SUCCESS = 'REGIONS_ADDED_SUCCESS'
export const REGIONS_DELETED_SUCCESS = 'REGIONS_DELETED_SUCCESS'
export const LIST_ALL_REGIONS = 'LIST_ALL_REGIONS'
export const REGIONS_UPDATED_SUCCESS = "REGIONS_UPDATED_SUCCESS"
export const REGIONS_ERROR = 'REGIONS_ERROR'
export const REGIONS_INFO_COUNT_SUCCESS = 'REGIONS_INFO_COUNT_SUCCESS'

/*RELEASE NOTES LIST*/
export const RELEASE_NOTE_DETAIL_SUCCESS = 'RELEASE_NOTE_DETAIL_SUCCESS'
export const RELEASE_NOTE_ADDED_SUCCESS = 'RELEASE_NOTE_ADDED_SUCCESS'
export const RELEASE_NOTES_DELETED_SUCCESS = 'RELEASE_NOTES_DELETED_SUCCESS'
export const LIST_ALL_RELEASE_NOTES = 'LIST_ALL_RELEASE_NOTES'
export const RELEASE_NOTES_UPDATED_SUCCESS = "RELEASE_NOTES_UPDATED_SUCCESS"
export const RELEASE_NOTE_ERROR = 'RELEASE_NOTE_ERROR'
export const RELEASE_NOTE_COUNT_SUCCESS = 'RELEASE_NOTE_COUNT_SUCCESS'


/* Master Data Document Types */
export const ON_ADD_DOCUMENT_TYPE = 'ON_ADD_DOCUMENT_TYPE'
export const ON_NEW_REQUEST_DOCUMENT = 'ON_NEW_REQUEST_DOCUMENT'
export const DOCUMENT_TYPE_LIST = 'DOCUMENT_TYPE_LIST'
export const DOCUMENT_TYPES_COUNT_SUCCESS = 'DOCUMENT_TYPES_COUNT_SUCCESS'
export const ON_DELETE_DOCUMENT_TYPE = 'ON_DELETE_DOCUMENT_TYPE'
export const DOCUMENT_TYPE_ERROR = 'DOCUMENT_TYPE_ERROR'
export const ON_UPDATED_DOCUMENT_TYPE = 'ON_UPDATED_DOCUMENT_TYPE'


/* Packaging Lists */
export const PACKAGING_LIST_PAGINATE = 'PACKAGING_LIST_PAGINATE'
export const PACKAGING_SUCCESS = 'PACKAGING_SUCCESS'
export const PACKAGING_ERROR = 'PACKAGING_ERROR'
export const UPDATE_PACKAGING = 'UPDATE_PACKAGING'
export const DELETE_PACKAGING = 'DELETE_PACKAGING'
export const ADD_PACKAGING = 'ADD_PACKAGING'
export const PACKAGING_DETAIL_SUCCESS = 'PACKAGING_DETAIL_SUCCESS'
export const PACKAGING_INFO_COUNT_SUCCESS = 'PACKAGING_INFO_COUNT_SUCCESS'
export const DIMENSIONS_LIST = 'DIMENSIONS_LIST'
export const DELETE_DIMENSIONS = 'DELETE_DIMENSIONS'
/* carriers*/

export const CARRIERS_DETAIL = 'CARRIERS_DETAIL'
export const CARRIERS_DETAIL_SUCCESS = 'CARRIERS_DETAIL_SUCCESS'
export const CARRIERS_DETAIL_ERROR = 'CARRIERS_DETAIL_ERROR'
export const CARRIER_INFO_COUNT_SUCCESS = 'CARRIER_INFO_COUNT_SUCCESS'


export const CARRIERS_ADDED = 'CARRIERS_ADDED'
export const CARRIERS_ADDED_SUCCESS = 'CARRIERS_ADDED_SUCCESS'
export const CARRIERS_ADDED_ERROR = 'CARRIERS_ADDED_ERROR'

export const CARRIERS_DELETED = 'CARRIERS_DELETED'
export const CARRIERS_DELETED_SUCCESS = 'CARRIERS_DELETED_SUCCESS'
export const CARRIERS_DELETED_ERROR = 'CARRIERS_DELETED_ERROR'
export const CARRIERS_ERROR = 'CARRIERS_ERROR'
export const ALL_CARRIERS_LIST = 'ALL_CARRIERS_LIST'
export const PACKAGING_CODE_SUCCESS = 'PACKAGING_CODE_SUCCESS'
export const PACKAGING_CODE_LIST = 'PACKAGING_CODE_LIST'
export const PACKAGING_CODE_ERROR = 'PACKAGING_CODE_ERROR'

export const CARRIERS_UPDATED_SUCCESS = "CARRIERS_UPDATED_SUCCESS"
export const CARRIERS_UPDATED_ERROR = "CARRIERS_UPDATED_ERROR"

/* Program Packagings Keys */
export const LIST_PROGRAM_COUNTRIES = 'LIST_PROGRAM_COUNTRIES'
export const PROGRAM_PACKAING_ERROR = 'PROGRAM_PACKAING_ERROR'
export const LIST_PACKAGING_LIST_ON_PROGRAMS = 'LIST_PACKAGING_LIST_ON_PROGRAMS'
export const LIST_PROGRAM_PACKAGING_LIST = 'LIST_PROGRAM_PACKAGING_LIST'
export const LIST_PROGRAM_PACKAGING_GRADE_LIST = 'LIST_PROGRAM_PACKAGING_GRADE_LIST'
export const ADD_PROGRAM_PACKAGING_LIST = 'ADD_PROGRAM_PACKAGING_LIST'
export const DELETE_PROGRAM_PACKAGING_LIST = 'DELETE_PROGRAM_PACKAGING_LIST'
export const PROGRAM_PACKING_INFO_COUNT = 'PROGRAM_PACKING_INFO_COUNT'
export const PROGRAM_PACKING_GRADE_INFO_COUNT = "PROGRAM_PACKING_GRADE_INFO_COUNT"
export const PACKING_SERVICES_INFORMATION = "PACKING_SERVICES_INFORMATION"

/* Countries */
export const COUNTRIES_DETAIL_SUCCESS = 'COUNTRIES_DETAIL_SUCCESS'

export const COUNTRIES_ADDED_SUCCESS = 'COUNTRIES_ADDED_SUCCESS'
export const ALL_COUNTRIES_LIST = 'ALL_COUNTRIES_LIST'
export const COUNTRIES_ERROR = 'COUNTRIES_ERROR'

export const PROGRAM_COUNTRIES_LIST = 'PROGRAM_COUNTRIES_LIST'
export const PROGRAM_COUNTRIES_LIST_ERROR = 'PROGRAM_COUNTRIES_LIST_ERROR'
export const PORTAL_USER_COUNTRIES_ADDED_SUCCESS = 'PORTAL_USER_COUNTRIES_ADDED_SUCCESS'
export const PORTAL_USER_COUNTRIES_ADDED_ERROR = 'PORTAL_USER_COUNTRIES_ADDED_ERROR'
export const PORTAL_USER_COUNTRIES_LIST = 'PORTAL_USER_COUNTRIES_LIST'
export const ALL_PORTAL_USER_COUNTRIES_LIST = "ALL_PORTAL_USER_COUNTRIES_LIST"
export const PORTAL_USER_COUNTRIES_LIST_ERROR = 'PORTAL_USER_COUNTRIES_LIST_ERROR'
export const DELETED_USER_COUNTRY = 'DELETED_USER_COUNTRY'
export const DELETED_USER_COUNTRY_ERROR = 'DELETED_USER_COUNTRY_ERROR'

export const COUNTRIES_DELETED_SUCCESS = 'COUNTRIES_DELETED_SUCCESS'

export const COUNTRIES_UPDATE_SUCCESS = "COUNTRIES_UPDATE_SUCCESS"

export const PORTAL_USER_COMPANIES_LIST = 'PORTAL_USER_COMPANIES_LIST';
export const PORTAL_USER_COMPANIES_ADD = 'PORTAL_USER_COMPANIES_ADD';
export const PORTAL_USER_COMPANIES_REMOVE = 'PORTAL_USER_COMPANIES_REMOVE';
export const PORTAL_USER_COMPANIES_REMOVE_ALL = 'PORTAL_USER_COMPANIES_REMOVE_ALL';
export const PORTAL_USER_COMPANIES_ERR = 'PORTAL_USER_COMPANIES_ERR';

/* Request Types */
export const MASTER_REQUEST_TYPES = 'MASTER_REQUEST_TYPES'
export const MASTER_REQUEST_TYPES_SUCCESS = 'MASTER_REQUEST_TYPES_SUCCESS'
export const MASTER_REQUEST_TYPES_COUNT_SUCCESS = 'MASTER_REQUEST_TYPES_COUNT_SUCCESS'
export const MASTER_REQUEST_TYPES_ERROR = 'MASTER_REQUEST_TYPES_ERROR'
export const MASTER_ADD_REQUEST_TYPES = 'MASTER_ADD_REQUEST_TYPES'
export const MASTER_ADD_REQUEST_TYPES_SUCCESS = 'MASTER_ADD_REQUEST_TYPES_SUCCESS'
export const MASTER_DELETE_REQUEST_TYPES = 'MASTER_DELETE_REQUEST_TYPES'
export const MASTER_DELETE_REQUEST_TYPES_SUCCESS = 'MASTER_DELETE_REQUEST_TYPES_SUCCESS'
export const MASTER_UPDATE_REQUEST_TYPES = 'MASTER_UPDATE_REQUEST_TYPES'
export const MASTER_UPDATE_REQUEST_TYPES_SUCCESS = 'MASTER_UPDATE_REQUEST_TYPES_SUCCESS'

/* Request Stages */
export const MASTER_REQUEST_STAGES = 'MASTER_REQUEST_STAGES'
export const MASTER_REQUEST_STAGES_SUCCESS = 'MASTER_REQUEST_STAGES_SUCCESS'
export const MASTER_REQUEST_STAGES_ERROR = 'MASTER_REQUEST_STAGES_ERROR'
export const MASTER_ADD_REQUEST_STAGES = 'MASTER_ADD_REQUEST_STAGES'
export const MASTER_ADD_REQUEST_STAGES_SUCCESS = 'MASTER_ADD_REQUEST_STAGES_SUCCESS'
export const MASTER_DELETE_REQUEST_STAGES = 'MASTER_DELETE_REQUEST_STAGES'
export const MASTER_DELETE_REQUEST_STAGES_SUCCESS = 'MASTER_DELETE_REQUEST_STAGES_SUCCESS'
export const MASTER_UPDATE_REQUEST_STAGES = 'MASTER_UPDATE_REQUEST_STAGES'
export const MASTER_UPDATE_REQUEST_STAGES_SUCCESS = 'MASTER_UPDATE_REQUEST_STAGES_SUCCESS'

/* Request Stage Input Fields */
export const MASTER_REQUEST_STAGE_INPUT_FIELDS = 'MASTER_REQUEST_STAGE_INPUT_FIELDS'
export const MASTER_REQUEST_STAGE_INPUT_FIELDS_SUCCESS = 'MASTER_REQUEST_STAGE_INPUT_FIELDS_SUCCESS'
export const MASTER_REQUEST_STAGE_INPUT_FIELDS_ERROR = 'MASTER_REQUEST_STAGE_INPUT_FIELDS_ERROR'
export const MASTER_ADD_REQUEST_STAGE_INPUT_FIELDS = 'MASTER_ADD_REQUEST_STAGE_INPUT_FIELDS'
export const MASTER_ADD_REQUEST_STAGE_INPUT_FIELDS_SUCCESS = 'MASTER_ADD_REQUEST_STAGE_INPUT_FIELDS_SUCCESS'
export const MASTER_DELETE_REQUEST_STAGE_INPUT_FIELDS = 'MASTER_DELETE_REQUEST_STAGE_INPUT_FIELDS'
export const MASTER_DELETE_REQUEST_STAGE_INPUT_FIELDS_SUCCESS = 'MASTER_DELETE_REQUEST_STAGE_INPUT_FIELDS_SUCCESS'
export const MASTER_UPDATE_REQUEST_STAGE_INPUT_FIELDS = 'MASTER_UPDATE_REQUEST_STAGE_INPUT_FIELDS'
export const MASTER_UPDATE_REQUEST_STAGE_INPUT_FIELDS_SUCCESS = 'MASTER_UPDATE_REQUEST_STAGE_INPUT_FIELDS_SUCCESS'

/* Request Stage Statuses */
export const MASTER_REQUEST_STAGE_STATUSES = 'MASTER_REQUEST_STAGE_STATUSES'
export const MASTER_REQUEST_STAGE_STATUSES_SUCCESS = 'MASTER_REQUEST_STAGE_STATUSES_SUCCESS'
export const MASTER_REQUEST_STAGE_STATUSES_ERROR = 'MASTER_REQUEST_STAGE_STATUSES_ERROR'
export const MASTER_ADD_REQUEST_STAGE_STATUSES = 'MASTER_ADD_REQUEST_STAGE_STATUSES'
export const MASTER_ADD_REQUEST_STAGE_STATUSES_SUCCESS = 'MASTER_ADD_REQUEST_STAGE_STATUSES_SUCCESS'
export const MASTER_DELETE_REQUEST_STAGE_STATUSES = 'MASTER_DELETE_REQUEST_STAGE_STATUSES'
export const MASTER_DELETE_REQUEST_STAGE_STATUSES_SUCCESS = 'MASTER_DELETE_REQUEST_STAGE_STATUSES_SUCCESS'
export const MASTER_UPDATE_REQUEST_STAGE_STATUSES = 'MASTER_UPDATE_REQUEST_STAGE_STATUSES'
export const MASTER_UPDATE_REQUEST_STAGE_STATUSES_SUCCESS = 'MASTER_UPDATE_REQUEST_STAGE_STATUSES_SUCCESS'
export const MASTER_STAGE_COUNT_SUCCESS = 'MASTER_STAGE_COUNT_SUCCESS'

/*Status */
export const STATUSES_LIST = "STATUSES_LIST"
export const STATUSES_ERROR = "STATUSES_ERROR"

/*TAKE BACK OPTIONS*/
export const TAKEBACKS = 'TAKEBACKS'
export const TAKEBACKOPTIONS_DETAIL = 'TAKEBACKOPTIONS_DETAIL'
export const TAKEBACKS_DETAIL_SUCCESS = 'TAKEBACKS_DETAIL_SUCCESS'
export const TAKEBACKS_DETAIL_ERROR = 'TAKEBACKS_DETAIL_ERROR'
export const TAKEBACKOPTIONS_ADDED_SUCCESS = 'TAKEBACKOPTIONS_ADDED_SUCCESS'
export const TAKEBACKOPTIONS_ADDED = 'TAKEBACKOPTIONS_ADDED'
export const TAKEBACKOPTIONS_ADDED_ERROR = 'TAKEBACKOPTIONS_ADDED_ERROR'
export const TAKEBACKOPTIONS_DELETED = 'TAKEBACKOPTIONS_DELETED'
export const TAKEBACKOPTIONS_DELETED_SUCCESS = 'TAKEBACKOPTIONS_DELETED_SUCCESS'
export const TAKEBACKOPTIONS_DELETED_ERROR = 'TAKEBACKOPTIONS_DELETED_ERROR'
export const TAKEBACKOPTIONS_UPDATE_SUCCESS = "TAKEBACKOPTIONS_UPDATE_SUCCESS"
export const TAKEBACKOPTIONS_UPDATE_ERROR = "TAKEBACKOPTIONS_UPDATE_ERROR"

/*PROCESSING PARTNERS*/
export const PROCESSES_DETAIL_SUCCESS = 'PROCESSES_DETAIL_SUCCESS'
export const PROCESSES_ADDED_SUCCESS = 'PROCESSES_ADDED_SUCCESS'
export const PROCESSES_DELETED_SUCCESS = 'PROCESSES_DELETED_SUCCESS'
export const PROCESSES_UPDATE_SUCCESS = "PROCESSES_UPDATE_SUCCESS"
export const PROCESSING_PARTNER_LIST_COUNT_SUCCESS = "PROCESSING_PARTNER_LIST_COUNT_SUCCESS"
export const PROCESSING_PARTNER_UPLOAD_SUCCESS = "PROCESSING_PARTNER_UPLOAD_SUCCESS"
export const PROCESSING_PARTNER_ERROR = "PROCESSING_PARTNER_ERROR"
export const PROCESSING_PARTNER_UPLOAD_ERROR = "PROCESSING_PARTNER_UPLOAD_ERROR"

export const PROGRAM_PROCESS_REQUEST_STAGE_STATUS_ERROR = 'PROGRAM_PROCESS_REQUEST_STAGE_STATUS_ERROR'
export const PROGRAM_STAGE_STATUS_LIST = 'PROGRAM_STAGE_STATUS_LIST'
export const ALL_PORTAL_STAGE_STATUS = 'ALL_PORTAL_STAGE_STATUS'
export const PROGRAM_STAGE_STATUS_ADDED = 'PROGRAM_STAGE_STATUS_ADDED'
export const PROGRAM_STAGE_STATUS_DELETED = 'PROGRAM_STAGE_STATUS_DELETED'
export const UPDATE_PROGRAM_STAGE_STATUS = 'UPDATE_PROGRAM_STAGE_STATUS'
export const PORTAL_REQUEST_STATUS_LIST = 'PORTAL_REQUEST_STATUS_LIST';

export const ASSETS_STATUS_LIST = 'ASSETS_STATUS_LIST';
export const ASSETS_STATUS_ERROR = 'ASSETS_STATUS_ERROR';
/* ASSETS */

export const ASSETS_DETAIL_SUCCESS = 'ASSETS_DETAIL_SUCCESS'
export const ASSETS_ERROR = 'ASSETS_ERROR'

export const ASSETS_ADDED_SUCCESS = 'ASSETS_ADDED_SUCCESS'

export const ASSETS_DELETED_SUCCESS = 'ASSETS_DELETED_SUCCESS'
export const SET_ALL_ASSETS = 'SET_ALL_ASSETS'

export const ASSETS_UPDATE_SUCCESS = "ASSETS_UPDATE_SUCCESS"

export const SETTING_DETAIL_SUCCESS = 'SETTING_DETAIL_SUCCESS'
export const SETTING_DETAIL_ERROR = 'SETTING_DETAIL_ERROR'

export const EMAIL_NOTIFICATION_DETAIL_SUCCESS = 'EMAIL_NOTIFICATION_DETAIL_SUCCESS'
export const EMAIL_NOTIFICATION_DETAIL_ERROR = 'EMAIL_NOTIFICATION_DETAIL_ERROR'
export const EMAIL_NOTIFICATION_ADDED_SUCCESS = 'EMAIL_NOTIFICATION_ADDED_SUCCESS'
export const EMAIL_NOTIFICATION_UPDATE_SUCCESS = 'EMAIL_NOTIFICATION_UPDATE_SUCCESS'
export const EMAIL_NOTIFICATION_DELETED_SUCCESS = 'EMAIL_NOTIFICATION_DELETED_SUCCESS'
export const EMAIL_NOTIFICATION_COUNT_SUCCESS = 'EMAIL_NOTIFICATION_COUNT_SUCCESS'


export const ASSETS_TYPE_DETAIL_SUCCESS = 'ASSETS_TYPE_DETAIL_SUCCESS'

export const ASSETS_TYPE_ADDED_SUCCESS = 'ASSETS_TYPE_ADDED_SUCCESS'

export const ASSETS_TYPE_DELETED_SUCCESS = 'ASSETS_TYPE_DELETED_SUCCESS'
export const SET_ALL_ASSETS_TYPE = 'SET_ALL_ASSETS_TYPE'

export const ASSETS_TYPE_UPDATE_SUCCESS = "ASSETS_TYPE_UPDATE_SUCCESS"

export const ADD_CLIENT_SERVICE_TYPE = 'ADD_CLIENT_SERVICE_TYPE'
export const UPDATE_CLIENT_SERVICE_TYPE = 'UPDATE_CLIENT_SERVICE_TYPE'
export const DELETE_CLIENT_SERVICE_TYPE = 'DELETE_CLIENT_SERVICE_TYPE'
export const CLIENT_SERVICE_TYPE_DELETE_ERROR = 'CLIENT_SERVICE_TYPE_DELETE_ERROR'
export const CLIENT_SERVICE_TYPE_ERROR = 'CLIENT_SERVICE_TYPE_ERROR'
export const UPDATE_COUNTRIES_BY_REGION = 'UPDATE_COUNTRIES_BY_REGION'
export const DELETE_COUNTRIES_BY_REGION = 'DELETE_COUNTRIES_BY_REGION'
// export const UPDATE_COUNTRIES = 'UPDATE_COUNTRIES'
// export const COUNTRIES_UPDATE_SUCCESS = 'COUNTRIES_UPDATE_SUCCESS'
// export const COUNTRIES_UPDATE_ERROR = 'COUNTRIES_UPDATE_ERROR'


// /* Client List */
// export const CLIENTS_LIST = 'CLIENTS_LIST'
// export const CLIENTS_LIST_SUCCESS = 'CLIENTS_LIST_SUCCESS'
// export const CLIENTS_LIST_ERROR= 'CLIENTS_LIST_ERROR'

// export const CLIENTS_ADDED = 'CLIENTS_ADDED'
// export const CLIENTS_ADDED_SUCCESS = 'CLIENTS_ADDED_SUCCESS'
// export const CLIENTS_ADDED_ERROR= 'CLIENTS_ADDED_ERROR'

// export const CLIENTS_DELETED = 'CLIENTS_DELETED'
// export const CLIENTS_DELETED_SUCCESS = 'CLIENTS_DELETED_SUCCESS'
// export const CLIENTS_DELETED_ERROR= 'CLIENTS_DELETED_ERROR'
export const GET_COUNTRY_EMAIL_NOTIFICATIONS = 'GET_COUNTRY_EMAIL_NOTIFICATIONS'



/* Program Processing Partners List */
export const PROGRAM_PROCESSING_PARTNERS_LIST = 'PROGRAM_PROCESSING_PARTNERS_LIST'
export const PROGRAM_PROCESSING_PARTNERS_FILTER = 'PROGRAM_PROCESSING_PARTNERS_FILTER'
export const PROGRAM_PROCESSING_PARNTER_ERROR = 'PROGRAM_PROCESSING_PARNTER_ERROR'
export const PROGRAM_PROCESSING_PARNTER_ADD = 'PROGRAM_PROCESSING_PARNTER_ADD'
export const DELETE_PROGRAM_PROCESSING_PARTNER = 'DELETE_PROGRAM_PROCESSING_PARTNER'
export const UPDATE_PROGRAM_PROCESSING_PARTNER = 'UPDATE_PROGRAM_PROCESSING_PARTNER'
export const PROGRAM_PROCESSING_PARTNER_INFO_COUNT = 'PROGRAM_PROCESSING_PARTNER_INFO_COUNT'
export const ALL_PROGRAM_PROCESSING_PARTNER_ERROR = 'ALL_PROGRAM_PROCESSING_PARTNER_ERROR'

export const GET_RECYLCLEPARTNER_LIST = "GET_RECYLCLEPARTNER_LIST_TYPE"
export const GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS = "GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS"
export const GET_RECYLCLEPARTNER_LIST_TYPE_ERROR = "GET_RECYLCLEPARTNER_LIST_TYPR_ERROR"

/* Client Processing Partners List */
export const CLIENT_PROCESSING_PARTNERS = 'CLIENT_PROCESSING_PARTNERS'
export const CLIENT_PROCESSING_ERROR = 'CLIENT_PROCESSING_ERROR'

/* Client Asset Data */
export const CLIENT_ALL_ASSETS_LIST = 'CLIENT_ALL_ASSETS_LIST'
export const CLIENT_ASSET_ERROR = 'CLIENT_ASSET_ERROR'

/* Program Carriers Data */
export const PROGRAM_ALL_CARRIER_LIST = 'PROGRAM_ALL_CARRIER_LIST'
export const PROGRAM_CARRIER_LIST = 'PROGRAM_CARRIER_LIST'
export const PROGRAM_CARRIER_ERROR = 'PROGRAM_CARRIER_ERROR'
export const ADD_PROGRAM_CARRIER_DATA = 'ADD_PROGRAM_CARRIER_DATA'
export const DELETE_PROGRAM_CARRIER = 'DELETE_PROGRAM_CARRIER'
export const DELETE_PROGRAM_DOCUMENT_TYPE = 'DELETE_PROGRAM_DOCUMENT_TYPE'
export const PROGRAM_CARRIER_INFO_COUNT = 'PROGRAM_CARRIER_INFO_COUNT'

/* Program Companies Data */
export const PROGRAM_COMPANY_LIST = 'PROGRAM_COMPANY_LIST'
export const PAGINATION_PROGRAM_COMPANY_LIST = 'PAGINATION_PROGRAM_COMPANY_LIST'
export const PROGRAM_COMPANY_LIST_COUNT = 'PROGRAM_COMPANY_LIST_COUNT'
export const PROGRAM_COMPANY_ERROR = 'PROGRAM_COMPANY_ERROR'
export const ADD_PROGRAM_COMPANY = 'ADD_PROGRAM_COMPANY'
export const DELETE_PROGRAM_COMPANY = 'DELETE_PROGRAM_COMPANY'
export const UPDATE_PROGRAM_COMPANY = 'UPDATE_PROGRAM_COMPANY'
export const PROGRAM_COMPANY_INFO_COUNT = 'PROGRAM_COMPANY_INFO_COUNT'
export const REMOVE_CONTACT_FROM_COMPANY = 'REMOVE_CONTACT_FROM_COMPANY'
export const UPDATE_CONTACT_FROM_COMPANY = 'UPDATE_CONTACT_FROM_COMPANY'

/*Porta contacts data */
export const PORTAL_CONTACT_ERROR = 'PORTAL_CONTACT_ERROR'
export const PORTAL_CONTACT_LIST  = 'PORTAL_CONTACT_LIST'
export const PAGINATION_PORTAL_CONTACT_LIST = 'PAGINATION_PORTAL_CONTACT_LIST'
export const PORTAL_CONTACT_LIST_COUNT = 'PORTAL_CONTACT_LIST_COUNT'
export const DELETE_PORTAL_CONTACT = 'DELETE_PORTAL_CONTACT'
export const ADD_PORTAL_CONTACT = 'ADD_PORTAL_CONTACT'
export const UPDATE_PORTAL_CONTACT = 'UPDATE_PORTAL_CONTACT'

/* Company contacts */
export const COMPANY_CONTACT_ERROR = 'COMPANY_CONTACT_ERROR'
export const COMPANY_CONTACT_LIST  = 'COMPANY_CONTACT_LIST'
// export const PAGINATION_COMPANY_CONTACT_LIST = 'PAGINATION_COMPANY_CONTACT_LIST'
// export const COMPANY_CONTACT_LIST_COUNT = 'COMPANY_CONTACT_LIST_COUNT'
export const DELETE_COMPANY_CONTACT = 'DELETE_COMPANY_CONTACT'
export const ADD_COMPANY_CONTACT = 'ADD_COMPANY_CONTACT'
export const UPDATE_COMPANY_CONTACT = 'UPDATE_COMPANY_CONTACT'

/* Program Brands Data */
export const GET_ALL_PROGRAM_BRANDS_SUCCESS = 'GET_ALL_PROGRAM_BRANDS_SUCCESS'
export const PROGRAM_BRANDS_LIST_SUCCESS = 'PROGRAM_BRANDS_LIST_SUCCESS'
export const PROGRAM_BRANDS_LIST_COUNT = 'PROGRAM_BRANDS_LIST_COUNT'
export const PROGRAM_BRANDS_ERROR = 'PROGRAM_BRANDS_ERROR'
export const ADD_PROGRAM_BRAND_DATA = 'ADD_PROGRAM_BRAND_DATA'
export const DELETE_PROGRAM_BRAND = 'DELETE_PROGRAM_BRAND'

/* Program Document Types */
export const PROGRAM_DOC_TYPE_ERROR = 'PROGRAM_DOC_TYPE_ERROR'
export const PROGRAM_DOC_TYPE_ITEM = 'PROGRAM_DOC_TYPE_ITEM'
export const PROGRAM_DOC_TYPE_LIST = 'PROGRAM_DOC_TYPE_LIST'
export const ADD_PROGRAM_DOC_TYPE_DATA = 'ADD_PROGRAM_DOC_TYPE_DATA'
export const PROGRAM_DOCUMENT_INFO_COUNT = 'PROGRAM_DOCUMENT_INFO_COUNT'

/* Program Client Document Types */
export const CLIENT_DOCUMENT_TYPE_LIST = 'CLIENT_DOCUMENT_TYPE_LIST'

export const CHART_REQUEST_TYPE_SUCCESS = 'CHART_REQUEST_TYPE_SUCCESS'
export const CHART_REQUEST_TYPE_ERROR = 'CHART_REQUEST_TYPE_ERROR'
export const CHART_REQUEST_STATUS_SUCCESS = 'CHART_REQUEST_STATUS_SUCCESS'


/* Request Document types */
export const REQUEST_DOCS_LIST = 'REQUEST_DOCS_LIST'
export const REQUEST_DOCS_ERROR = 'REQUEST_DOCS_ERROR'
export const ADDED_REQUEST_DOCUMNET = 'ADDED_REQUEST_DOCUMNET'
export const REQUEST_CIRCLE_DOCS_LIST = 'REQUEST_CIRCLE_DOCS_LIST'
export const REQUEST_DOCS_DOWNLOAD = 'REQUEST_DOCS_DOWNLOAD'
export const REQUEST_DOC_DELETED = 'REQUEST_DOC_DELETED'
export const REQUEST_DOC_ITEM = 'REQUEST_DOC_ITEM'

/* Portal Level Document Types */
export const REPORT_DOCS_ERROR = 'REPORT_DOCS_ERROR'
export const REPORT_DOCS_LIST = 'REPORT_DOCS_LIST'
export const REPORT_DOC_COUNT = 'REPORT_DOC_COUNT'
export const PORTAL_DOC_DELETED = 'PORTAL_DOC_DELETED'
export const REPORT_TAG_DETAILS = 'REPORT_TAG_DETAILS'
/* Program Boxes types */
export const PROGRAM_BOXES_DATA = 'PROGRAM_BOXES_DATA'
export const PROGRAM_BOXES_ERROR = 'PROGRAM_BOXES_ERROR'
export const PROGRAM_BOX_ADDED = 'PROGRAM_BOX_ADDED'
export const PROGRAM_BOX_DELETED = 'PROGRAM_BOX_DELETED'
export const PROGRAM_BOX_INFO_COUNT = 'PROGRAM_BOX_INFO_COUNT'

/* Program Label types */
export const PROGRAM_LABELS_DATA = 'PROGRAM_LABELS_DATA'
export const PROGRAM_LABELS_ERROR = 'PROGRAM_LABELS_ERROR'
export const PROGRAM_LABEL_ADDED = 'PROGRAM_LABEL_ADDED'
export const PROGRAM_LABEL_DELETED = 'PROGRAM_LABEL_DELETED'
export const PROGRAM_LABEL_INFO_COUNT = 'PROGRAM_LABEL_INFO_COUNT'

/* Program Countries types */
export const PROGRAM_COUNTIRES_LIST = 'PROGRAM_COUNTIRES_LIST'
export const ON_ADD_PROGRAM_COUNTRY = 'ON_ADD_PROGRAM_COUNTRY'
export const UPDATED_PROGRAM_COUNTRY_DATA = 'UPDATED_PROGRAM_COUNTRY_DATA'
export const DELETED_PROGRAM_COUNTRY = 'DELETED_PROGRAM_COUNTRY'
export const PROGRAM_COUNTRIES_ERROR = 'PROGRAM_COUNTRIES_ERROR'

export const ALL_PROGRAM_COUNTRIES_LIST = "ALL_PROGRAM_COUNTRIES_LIST"
export const ALL_PROGRAM_COUNTRIES_ERROR = "ALL_PROGRAM_COUNTRIES_ERROR"

/*Program questions type */
export const PROGRAM_FEEDBACK_QUESTION_ERROR = 'PROGRAM_FEEDBACK_QUESTION_ERROR'
export const PROGRAM_FEEDBACK_QUESTIONS_UPDATED_SUCCESS = 'PROGRAM_FEEDBACK_QUESTIONS_UPDATED_SUCCESS'

/* Program Process Request Types */
export const PROGRAM_REQUEST_TYPES_LIST = 'PROGRAM_REQUEST_TYPES_LIST'
export const PROGRAM_REQUEST_TYPES_SEQUENCE = 'PROGRAM_REQUEST_TYPES_SEQUENCE'
export const PROGRAM_REQUEST_STAGES_LIST = 'PROGRAM_REQUEST_STAGES_LIST'
export const ADDED_PROGRAM_REQUEST_STAGE = 'ADDED_PROGRAM_REQUEST_STAGE'
export const DELETE_PROGRAM_REQUEST_STAGE = 'DELETE_PROGRAM_REQUEST_STAGE'
export const PROGRAM_STAGE_DIRCETION_CHANGE = 'PROGRAM_STAGE_DIRCETION_CHANGE'
export const PROGRAM_STAGE_QRCODE_ACCESS_LEVEL = 'PROGRAM_STAGE_QRCODE_ACCESS_LEVEL'
export const PROGRAM_PROCESS_ERROR = 'PROGRAM_PROCESS_ERROR'
export const PROGRAM_REQUEST_INFO_COUNT = 'PROGRAM_REQUEST_INFO_COUNT'
export const ADDED_PACKAGE_INSTRUCTION_DOCUMNET = "ADDED_PACKAGE_INSTRUCTION_DOCUMNET"
export const PACKAGE_INSTRUCTION_ERROR = "PACKAGE_INSTRUCTION_ERROR"

export const REQUEST_STAGES = 'REQUEST_STAGES'
export const REQUEST_STAGES_ERROR = 'REQUEST_STAGES_ERROR'

/* Program Request Stage Input Fileds  */
export const PROGRAM_PROCESS_REQUEST_STAGE_INPUT_DATA = 'PROGRAM_PROCESS_REQUEST_STAGE_INPUT_DATA'
export const PROGRAM_PROCESS_REQUEST_STAGE_ADDED_INPUT_FIELD = 'PROGRAM_PROCESS_REQUEST_STAGE_ADDED_INPUT_FIELD'
export const PROGRAM_PROCESS_REQUEST_STAGE_UPDATED_INPUT_FIELD = 'PROGRAM_PROCESS_REQUEST_STAGE_UPDATED_INPUT_FIELD'
export const PROGRAM_PROCESS_REQUEST_STAGE_DELETED_INPUT_FIELD = 'PROGRAM_PROCESS_REQUEST_STAGE_DELETED_INPUT_FIELD'
export const PROGRAM_PROCESS_REQUEST_STAGE_ERROR = 'PROGRAM_PROCESS_REQUEST_STAGE_ERROR'

/* Program Assets Data */
export const PROGRAM_ASSETS_LIST = 'PROGRAM_ASSETS_LIST'
export const PROGRAM_ASSETS_LIST_WITH_DATA_BEARING = 'PROGRAM_ASSETS_LIST_WITH_DATA_BEARING'
export const ON_ADD_PROGRAM_ASSET = 'ON_ADD_PROGRAM_ASSET'
export const PROGRAM_ASSETS_ERROR = 'PROGRAM_ASSETS_ERROR'
export const UPDATED_PROGRAM_ASSET = 'UPDATED_PROGRAM_ASSET'
export const DELETED_PROGRAM_ASSET = 'DELETED_PROGRAM_ASSET'
export const PROGRAM_ASSET_INFO_COUNT = "PROGRAM_ASSET_INFO_COUNT"
export const GROUP_ID = "GROUP_ID"
export const GROUP_USER_DATA = "GROUP_USER_DATA"


/* Program Request Types */

export const LIST_PROGRAM_REQUEST_TYPES = 'LIST_PROGRAM_REQUEST_TYPES'
export const ADD_REQUEST_TYPES = 'ADD_REQUEST_TYPES'
export const DELETE_REQUEST_TYPES = 'DELETE_REQUEST_TYPES'

export const REQUEST_TYPES_DATA = 'REQUEST_TYPES_DATA'
export const REQUEST_TYPES_ADDED = 'REQUEST_TYPES_ADDED'
export const REQUEST_TYPES_DELETED = 'REQUEST_TYPES_DELETED'
export const REQUEST_TYPES_ERROR = 'REQUEST_TYPES_ERROR'


export const ALL_REQUEST_TYPES = 'ALL_REQUEST_TYPES'

export const UPDATED_PROGRAM_REQUEST_TYPE = 'UPDATED_PROGRAM_REQUEST_TYPE'
export const ALL_REQUEST_TYPES_URL = 'ALL_REQUEST_TYPES_URL'

/* Program Stores */
export const ALL_STORE_LOCATIONS = 'ALL_STORE_LOCATIONS'
export const PORTAL_STORAGE_INFO = 'PORTAL_STORAGE_INFO'
export const STORE_ERROR = 'STORE_ERROR'
export const SET_PORTAL_STORAGE = 'SET_PORTAL_STORAGE'
export const SET_PORTAL_STORAGE_CONFIRMED = 'SET_PORTAL_STORAGE_CONFIRMED'
export const PORTAL_STORE_ERROR = 'PORTAL_STORE_ERROR'


/* Home Ofc Portal Store */
export const HOME_OFFICE_STORE_CONFIGURATION = 'HOME_OFFICE_STORE_CONFIGURATION'
export const HOME_OFFICE_STORE_CONFIGURATION_ERROR = 'HOME_OFFICE_STORE_CONFIGURATION_ERROR'

/* Users Information */
export const LIST_USER_DATA = 'LIST_USER_DATA'
export const MASTER_USER_PAGE_LAST_EVALUATED_KEY = 'MASTER_USER_PAGE_LAST_EVALUATED_KEY'
export const LIST_ADMIN_USERS_CONFIGURATIONS = 'LIST_ADMIN_USERS_CONFIGURATIONS'
export const LIST_ADMIN_USERS_CONFIGURATIONS_COUNT  = 'LIST_ADMIN_USERS_CONFIGURATIONS_COUNT'
export const DELETE_ADMIN_USERS = 'DELETE_ADMIN_USERS'
export const LIST_ADMIN_USERS_COUNT = "LIST_ADMIN_USERS_COUNT"
export const LIST_ADMIN_USER_PAGE_COUNT = "LIST_ADMIN_USER_PAGE_COUNT"
export const USERS_ERROR = 'USERS_ERROR'
export const NEW_ADDED_USER = 'NEW_ADDED_USER'
export const USER_ROLES_DATA = 'USER_ROLES_DATA'
export const ALL_USER_ROLES_DATA = 'ALL_USER_ROLES_DATA'
export const ALL_PORTAL_DATA = 'ALL_PORTAL_DATA'
export const USER_ROLE_ERROR = 'USER_ROLE_ERROR'
export const SELECTED_USER_DATA = 'SELECTED_USER_DATA'
export const ADDED_USER_ROLE = 'ADDED_USER_ROLE'
export const DELETED_USER_ROLE = 'DELETED_USER_ROLE'

export const USER_CLIENTS_ERROR = 'USER_CLIENTS_ERROR'
export const USER_CLIENTS_DATA = 'USER_CLIENTS_DATA'
export const USERS_CLIENTS_DATA = 'USERS_CLIENTS_DATA'
export const USER_PORTALS_DATA = 'USER_PORTALS_DATA'
export const DELETED_USER_PORTAL = 'DELETED_USER_PORTAL'

export const ADDED_USER_PORTAL = 'ADDED_USER_PORTAL'
export const ADDED_USER_CLIENT_INFO = 'ADDED_USER_CLIENT_INFO'
export const DELETED_USER_CLIENT_INFO = 'DELETED_USER_CLIENT_INFO'
export const SAVE_CURRENT_PAGE = 'SAVE_CURRENT_PAGE'
export const DELETE_FORMATTED_CLIENTS = 'DELETE_FORMATTED_CLIENTS'
export const USER_FORMATTED_CLIENTS = 'USER_FORMATTED_CLIENTS'
/* All Roles */
export const ALL_ROLES_DATA = 'ALL_ROLES_DATA'
export const USER_ROLE_LIST = 'USER_ROLE_LIST'
export const ADDED_ROLE = 'ADDED_ROLE'
export const UPDATED_ROLE = 'UPDATED_ROLE'
export const DELETED_ROLE_DATA = 'DELETED_ROLE_DATA'
export const ADDED_NEW_FORMATTED_CLIENT = 'ADDED_NEW_FORMATTED_CLIENT'
export const RIGHTS_BY_ROLE_DATA = 'RIGHTS_BY_ROLE_DATA'

/* All RightObjects */
export const ALL_RIGHT_OBJECTS_DATA = 'ALL_RIGHT_OBJECTS_DATA'
export const RIGHT_OBJECTS_ERROR = 'RIGHT_OBJECTS_ERROR'

/* Password Handling */
export const ADMIN_FORGOT_PASSWORD_ERROR = 'ADMIN_FORGOT_PASSWORD_ERROR'
export const ADMIN_CHANGE_PASSWORD_ERROR = 'ADMIN_CHANGE_PASSWORD_ERROR'

/* Service Type */
export const GET_SERVICE_TYPE = 'GET_SERVICE_TYPE'
export const ADD_SERVICE_TYPE = 'ADD_SERVICE_TYPE'
export const DELETE_SERVICE_TYPE = 'DELETE_SERVICE_TYPE'
export const UPDATE_SERVICE_TYPE = 'UPDATE_SERVICE_TYPE'
export const SERVICE_TYPE_ERROR = 'SERVICE_TYPE_ERROR'
export const SERVICE_TYPE_COUNT_SUCCESS = 'SERVICE_TYPE_COUNT_SUCCESS'

/* Service Type */
export const GET_SERVICE = 'GET_SERVICE'
export const ADD_SERVICE = 'ADD_SERVICE'

export const GET_CLIENT_SERVICE_TYPE = 'GET_CLIENT_SERVICE_TYPE'

export const DELETE_SERVICE = 'DELETE_SERVICE'
export const DELETED_SERVICE = 'DELETED_SERVICE'

export const UPDATE_SERVICE = 'DELETE_SERVICE'
export const MASTER_SERVICES_ERROR = 'MASTER_SERVICES_ERROR'


/* ------------- Portal User Constants ------------ */
export const LIST_PORTAL_USER = 'LIST_PORTAL_USER'
export const PORTAL_USER_PAGE_LAST_EVALUATED_KEY = 'PORTAL_USER_PAGE_LAST_EVALUATED_KEY'
export const DELETE_PORTAL_USER = 'DELETE_PORTAL_USER'
export const PORTAL_USER_ADDED = 'PORTAL_USER_ADDED'
export const PORTAL_USER_ERROR = 'PORTAL_USER_ERROR'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_DETAILS_BY_USER_ID = 'USER_DETAILS_BY_USER_ID'
export const USER_DETAILS_BY_USER_ID_FAILED = 'USER_DETAILS_BY_USER_ID_FAILED'
export const USER_DETAILS = 'USER_DETAILS'
export const USER_FAILED = "USER_FAILED"
export const PORTAL_USER_UPDATED = 'PORTAL_USER_UPDATED'
export const PORTAL_ONE_USER_INFO = 'PORTAL_ONE_USER_INFO'
export const PORTAL_USER_ACTIVATION_RESEND_FAILED = 'PORTAL_USER_ACTIVATION_RESEND_FAILED'
export const INDV_PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS = 'INDV_PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS'


export const GET_ADDITIONAL_INFO_SUCCESS = "GET_ADDITIONAL_INFO_SUCCESS"
export const GET_ADDITIONAL_INFO_DATA_SUCCESS = "GET_ADDITIONAL_INFO_DATA_SUCCESS"
export const GET_ADDITIONAL_INFO_ERROR = "GET_ADDITIONAL_INFO_ERROR"
export const GET_ADDITIONAL_INFO_DATA_ERROR = "GET_ADDITIONAL_INFO_DATA_ERROR"


export const CLIENT_SERVICES_SUCCESS = "CLIENT_SERVICES_SUCCESS"
export const CLIENT_SERVICES_ERROR = "CLIENT_SERVICES_ERROR"

export const GET_REQUEST_PACKING_SUCCESS = "GET_REQUEST_PACKING_SUCCESS"
export const BOX_OR_PACK_ERROR = "BOX_OR_PACK_ERROR"
export const GET_REQUEST_SERVICE = "GET_REQUEST_SERVICE"
export const GET_REQUEST_SERVICE_ERROR = "GET_REQUEST_SERVICE_ERROR"
export const REQUEST_QUOTE_DETAILS = "REQUEST_QUOTE_DETAILS"

export const GET_COLLECTION_SITE = "GET_COLLECTION_SITE"
export const GET_DESTINATION_SITE = "GET_DESTINATION_SITE"
export const REQUEST_DETAIL_ERROR = "REQUEST_DETAIL_ERROR"
export const PORTAL_COLLECTION_ADDRESS_ERROR = "PORTAL_COLLECTION_ADDRESS_ERROR"
export const UPDATED_COLLECTION_ADDRESS = "UPDATED_COLLECTION_ADDRESS"
export const GET_COLLECTION_ADDRESS_BY_SITE = "GET_COLLECTION_ADDRESS_BY_SITE"
export const PROGRAM_COLLECTION_BULK_UPLOAD_DATA = 'PROGRAM_COLLECTION_BULK_UPLOAD_DATA'

export const GET_ADDRESS_LIST = "GET_ADDRESS_LIST"

/** User Logs */
export const PORTAL_LOG_ERROR = "PORTAL_LOG_ERROR"
export const USER_LOGS_INFO = "USER_LOGS_INFO"
export const PORTAL_USER_LOGS_INFO = "PORTAL_USER_LOGS_INFO"

/** MODULE Logs */
export const MODULE_LOG_ERROR = "MODULE_LOG_ERROR"
export const MODULE_LOGS_INFO = "MODULE_LOGS_INFO"
export const MODULE_LOGS_COUNT = "MODULE_LOGS_COUNT"
export const CHANGE_LOG_SETTINGS_SUCCESS = 'CHANGE_LOG_SETTINGS_SUCCESS'
export const CHANGE_LOG_SETTINGS_ERROR = 'CHANGE_LOG_SETTINGS_ERROR'

/** Portal Additional Fields */
export const PORTAL_ADDITIONAL_FIELD_DATA = "PORTAL_ADDITIONAL_FIELD_DATA"
export const PORTAL_ADDITIONAL_FIELD_ERROR = "PORTAL_ADDITIONAL_FIELD_ERROR"
export const REQUEST_ADDITIONAL_FIELD_DATA = "REQUEST_ADDITIONAL_FIELD_DATA"
export const DELETED_PORTAL_ADDITIONAL_FIELD_DATA = "DELETED_PORTAL_ADDITIONAL_FIELD_DATA"
export const ADDED_PORTAL_ADDITIONAL_FIELD_DATA = "ADDED_PORTAL_ADDITIONAL_FIELD_DATA"
export const UPDATED_PORTAL_ADDITIONAL_FIELD_DATA = "UPDATED_PORTAL_ADDITIONAL_FIELD_DATA"
export const ADDITIONAL_FIELD_COUNT_SUCCESS = "ADDITIONAL_FIELD_COUNT_SUCCESS"
/**Admin Chart */
export const REQUEST_TYPE_CHART_SUCCESS = "REQUEST_TYPE_CHART_SUCCESS"
export const REQUEST_TYPE_CHART_ERROR = "REQUEST_TYPE_CHART_ERROR"
export const REQUEST_STATUS_CHART_SUCCESS = "REQUEST_STATUS_CHART_SUCCESS"
export const REQUEST_STATUS_CHART_ERROR = "REQUEST_STATUS_CHART_ERROR"
export const REQUEST_CLIENT_CHART_SUCCESS = "REQUEST_CLIENT_CHART_SUCCESS"
export const REQUEST_CLIENT_CHART_ERROR = "REQUEST_CLIENT_CHART_ERROR"
export const REQUEST_PROCESSING_CHART_SUCCESS = "REQUEST_PROCESSING_CHART_SUCCESS"
export const REQUEST_PROCESSING_CHART_ERROR = "REQUEST_PROCESSING_CHART_ERROR"

export const ASSIGN_PO = "ASSIGN_PO"
export const ASSIGN_PO_ERROR = "ASSIGN_PO_ERROR"
export const GET_ASSIGN_PO = "GET_ASSIGN_PO"
export const ASSIGN_PO_UPDATE = "ASSIGN_PO_UPDATE"

export const LIST_ALL_PO = "LIST_ALL_PO"
export const PO_LIST_ERROR = "PO_LIST_ERROR"
export const PO_DETAIL_DATA = "PO_DETAIL_DATA"
export const PO_INFO_COUNT = "PO_INFO_COUNT"

export const PROGRAM_DATA = 'PROGRAM_DATA'
export const PROGRAM_ERROR = 'PROGRAM_ERROR'

export const PORTAL_GROUP_DATA = 'PORTAL_GROUP_DATA'
export const PORTAL_GROUP_ADD_DATA = 'PORTAL_GROUP_ADD_DATA'
export const PORTAL_GROUP_ERR = 'PORTAL_GROUP_ERR'

export const PORTAL_MODULE_DATA = 'PORTAL_MODULE_DATA'
export const PORTAL_MODULE_ERR = 'PORTAL_MODULE_ERR'

export const PORTAL_USER_GROUP_DATA = 'PORTAL_USER_GROUP_DATA'
export const PORTAL_USER_GROUP_ERR = 'PORTAL_USER_GROUP_ERR'

export const REQUEST_EXCEL_DOCS_ERROR = 'REQUEST_EXCEL_DOCS_ERROR'



export const REPORT_MODULE_DATA = "REPORT_MODULE_DATA"
export const REPORT_MODULE_ERR = "REPORT_MODULE_ERR"
export const REPORT_MODULE_ADD = "REPORT_MODULE_ADD"
export const GROUP_DATA = "GROUP_DATA"
export const UPDATE_PORTAL_GROUP = "UPDATE_PORTAL_GROUP"
export const GROUP_ADD = "GROUP_ADD"
export const GROUP_ERR = "GROUP_ERR"

export const REQ_TYPE_DATA = "REQ_TYPE_DATA"
export const REQ_TYPE_ERR = "REQ_TYPE_ERR"

export const P_COUNTRY_DATA = "P_COUNTRY_DATA"
export const P_COUNTRY_ERR = "P_COUNTRY_ERR"

export const SITE_DATA = "SITE_DATA"
export const SITE_ERR = "SITE_ERR"

export const USER_ADDED = "USER_ADDED"
export const USER_ERR = "USER_ERR"
export const USER_BY_ID_INFO = "USER_BY_ID_INFO"
export const LIST_USER = "LIST_USER"
export const USER_GROUP = "USER_GROUP"
export const USER_GROUP_LOADING = "USER_GROUP_LOADING"
export const PORTAL_USER_GROUP = "PORTAL_USER_GROUP"
export const USER_GROUP_ERR = "USER_GROUP_ERR"
export const SAVE_FILTER = "SAVE_FILTER"

//ADDITIONAL INFO
export const ADDITIONAL_INFO_SUCCESS = "ADDITIONAL_INFO_SUCCESS"
export const ADDITIONAL_INFO_ERROR = 'ADDITIONAL_INFO_ERROR'
export const ADDITIONAL_INFO_ADDED_SUCCESS = "ADDITIONAL_INFO_ADDED_SUCCESS"
export const ADDITIONAL_INFO_ADD_ERROR = 'ADDITIONAL_INFO_ADD_ERROR'
export const ADDITIONAL_INFO_UPDATE_SUCCESS = "ADDITIONAL_INFO_UPDATE_SUCCESS"
export const ADDITIONAL_INFO_DELETED_SUCCESS = "ADDITIONAL_INFO_DELETED_SUCCESS"

export const SET_ALL_ADDITIONAL_INFO = "SET_ALL_ADDITIONAL_INFO"
export const CLIENT_ADDITIONAL_INFO_LIST = "CLIENT_ADDITIONAL_INFO_LIST"
export const CLIENT_ADDITIONAL_INFO_ADDED_SUCCESS = "CLIENT_ADDITIONAL_INFO_ADDED_SUCCESS"
export const CLIENT_ADDITIONAL_INFO_DELETED_SUCCESS = "CLIENT_ADDITIONAL_INFO_DELETED_SUCCESS"

export const PROGRAM_ADDITIONAL_INFO_LIST = "PROGRAM_ADDITIONAL_INFO_LIST"
export const ON_ADD_PROGRAM_ADDITIONAL_INFO = "ON_ADD_PROGRAM_ADDITIONAL_INFO"
export const ADD_PROGRAM_ADDITIONAL_INFO_COUNT = "ADD_PROGRAM_ADDITIONAL_INFO_COUNT"
export const DELETED_PROGRAM_ADDITIONAL_INFO = "DELETED_PROGRAM_ADDITIONAL_INFO"

export const ADDITIONAL_INFO_COUNT_SUCCESS = "ADDITIONAL_INFO_COUNT_SUCCESS"
export const COUNTRY_INFO_COUNT_SUCCESS = "COUNTRY_INFO_COUNT_SUCCESS"
export const PROGRAM_COUNTRY_INFO_COUNT = "PROGRAM_COUNTRY_INFO_COUNT"



// Verification Of User Account Functionality.
export const INITIATE_SET_PASSWORD_SUCCESS = "INITIATE_SET_PASSWORD_SUCCESS"
export const PORTAL_USER_ACTIVATION_FAILED = "PORTAL_USER_ACTIVATION_FAILED"
export const USER_ACCOUNT_ACTIVATED_FAILED = "USER_ACCOUNT_ACTIVATED_FAILED"
export const USER_ACTIVATION_INITIATE_RESEND_ACTIVATION = "USER_ACTIVATION_INITIATE_RESEND_ACTIVATION"
export const PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS = "PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS"
export const SET_ADMIN_RESEND_ERROR_MESSAGE = "SET_ADMIN_RESEND_ERROR_MESSAGE"

export const SYNCING_BOM_MAINTENANCE_LIST = "SYNCING_BOM_MAINTENANCE_LIST"
export const SYNCING_BOM_MAINTENANCE_LIST_FAIL = "SYNCING_BOM_MAINTENANCE_LIST_FAIL"
export const SYNCING_INSTANCES_LIST = "SYNCING_INSTANCES_LIST"
export const SYNCING_INSTANCES_LIST_FAIL = "SYNCING_INSTANCES_LIST_FAIL"
export const MASTER_ASSET_TYPE_BY_ID = "MASTER_ASSET_TYPE_BY_ID"
export const MASTER_ASSET_TYPE_BY_ID_ERROR = "MASTER_ASSET_TYPE_BY_ID_ERROR"
export const MASTER_PART_BY_ID = "MASTER_PART_BY_ID"
export const MASTER_PART_BY_ID_ERROR = "MASTER_PART_BY_ID_ERROR"

export const ADD_INSTANCE_SUCCESS = "ADD_INSTANCE_SUCCESS"
export const ADD_INSTANCE_FAIL = "ADD_INSTANCE_FAIL"
export const DELETE_INSTANCE_SUCCESS = "DELETE_INSTANCE_SUCCESS"
export const DELETE_INSTANCE_FAIL = "DELETE_INSTANCE_FAIL"

export const SINGLE_INSTANCE_DETAILS = "SINGLE_INSTANCE_DETAILS"
export const SINGLE_INSTANCE_DETAILS_FAIL = "SINGLE_INSTANCE_DETAILS_FAIL"


export const SYNCING_PENDING_BOM_LIST = "SYNCING_PENDING_BOM_LIST"
export const SYNCING_PENDING_BOM_LIST_FAIL = "SYNCING_PENDING_BOM_LIST_FAIL"
export const SYNCING_PENDING_PART_LIST = "SYNCING_PENDING_PART_LIST"
export const SYNCING_PENDING_PART_LIST_FAIL = "SYNCING_PENDING_PART_LIST_FAIL"

export const SYNCING_ASSET_TYPE_LIST = "SYNCING_ASSET_TYPE_LIST"
export const SYNCING_ASSET_TYPE_LIST_FAIL = "SYNCING_ASSET_TYPE_LIST_FAIL"
export const SYNCING_ASSET_TYPE_DETAILS = "SYNCING_ASSET_TYPE_DETAILS"
export const SYNCING_ASSET_TYPE_APPROVE_DETAILS = "SYNCING_ASSET_TYPE_APPROVE_DETAILS"
export const SYNCING_ASSET_TYPE_APPROVE_DETAILS_FAIL = "SYNCING_ASSET_TYPE_APPROVE_DETAILS_FAIL"
export const SYNCING_ASSET_TYPE_EDIT_DETAILS = "SYNCING_ASSET_TYPE_EDIT_DETAILS"
export const SYNCING_ASSET_TYPE_EDIT_DETAILS_FAIL = "SYNCING_ASSET_TYPE_EDIT_DETAILS_FAIL"


export const SYNCING_PART_MAINTENANCE_DETAILS = "SYNCING_PART_MAINTENANCE_DETAILS"
export const SYNCING_PART_MAINTENANCE_APPROVE_DETAILS = "SYNCING_PART_MAINTENANCE_APPROVE_DETAILS"
export const SYNCING_PART_MAINTENANCE_APPROVE_DETAILS_FAIL = "SYNCING_PART_MAINTENANCE_APPROVE_DETAILS_FAIL"
export const SYNCING_PART_MAINTENANCE_EDIT_DETAILS = "SYNCING_PART_MAINTENANCE_EDIT_DETAILS"
export const SYNCING_PART_MAINTENANCE_EDIT_DETAILS_FAIL = "SYNCING_PART_MAINTENANCE_EDIT_DETAILS_FAIL"
export const SYNCING_PART_MAINTENANCE_ASSET_TYPE_DETAILS = "SYNCING_PART_MAINTENANCE_ASSET_TYPE_DETAILS"
export const SYNCING_PART_MAINTENANCE_LIST = "SYNCING_PART_MAINTENANCE_LIST"
export const SYNCING_PART_MAINTENANCE_LIST_FAIL = "SYNCING_PART_MAINTENANCE_LIST_FAIL"

export const SYNCING_WASTE_NUMBERS_LIST_SUCCESS = "SYNCING_WASTE_NUMBERS_LIST_SUCCESS"
export const SYNCING_WASTE_NUMBERS_LIST_FAILED = "SYNCING_WASTE_NUMBERS_LIST_FAILED"
export const SYNCING_SET_TAB = "SYNCING_SET_TAB"


export const SET_SYNC_STATUS = "SET_SYNC_STATUS"
export const REJECT_ASSET_TYPE_DETAILS_SUCCESS = "REJECT_ASSET_TYPE_DETAILS"
export const REJECT_PART_MAINTENANCE_DETAILS_SUCCESS = "REJECT_PART_MAINTENANCE_DETAILS_SUCCESS"
export const LOCK_OR_UNLOCK_ASSET_TYPE_DETAILS_SUCCESS = "LOCK_OR_UNLOCK_ASSET_TYPE_DETAILS"
export const LOCK_OR_UNLOCK_PART_MAINTENANCE_DETAILS_SUCCESS = "LOCK_OR_UNLOCK_PART_MAINTENANCE_DETAILS_SUCCESS"

export const REJECT_ASSET_TYPE_DETAILS_FAILED = "REJECT_ASSET_TYPE_DETAILS_FAILED"
export const REJECT_PART_MAINTENANCE_DETAILS_FAILED = "REJECT_PART_MAINTENANCE_DETAILS_FAILED"

export const LOCK_OR_UNLOCK_ASSET_TYPE_DETAILS_FAILED = "LOCK_OR_UNLOCK_ASSET_TYPE_DETAILS_FAILED"
export const LOCK_OR_UNLOCK_PART_MAINTENANCE_DETAILS_FAILED = "LOCK_OR_UNLOCK_PART_MAINTENANCE_DETAILS_FAILED"

export const SYNCING_ASSET_TYPE_DETAILS_FAIL = "SYNCING_ASSET_TYPE_DETAILS_FAIL"
export const SYNCING_PART_MAINTENANCE_DETAILS_FAIL = "SYNCING_PART_MAINTENANCE_DETAILS_FAIL"
export const SYNCING_PART_MAINTENANCE_ASSET_TYPE_DETAILS_FAIL = "SYNCING_PART_MAINTENANCE_ASSET_TYPE_DETAILS_FAIL"

export const SYNCING_APPROVED_BOM_LIST = "SYNCING_APPROVED_BOM_LIST"
export const SYNCING_APPROVED_BOM_LIST_FAIL = "SYNCING_APPROVED_BOM_LIST_FAIL"
export const SYNCING_APPROVED_PART_LIST = "SYNCING_APPROVED_PART_LIST"
export const SYNCING_APPROVED_PART_LIST_FAIL = "SYNCING_APPROVED_PART_LIST_FAIL"

export const SYNCING_REJECTED_ASSET_LIST = "SYNCING_REJECTED_ASSET_LIST"
export const SYNCING_REJECTED_ASSET_LIST_FAIL = "SYNCING_REJECTED_ASSET_LIST_FAIL"
export const SYNCING_REJECTED_BOM_LIST = "SYNCING_REJECTED_BOM_LIST"
export const SYNCING_REJECTED_BOM_LIST_FAIL = "SYNCING_REJECTED_BOM_LIST_FAIL"
export const SYNCING_REJECTED_PART_LIST = "SYNCING_REJECTED_PART_LIST"
export const SYNCING_REJECTED_PART_LIST_FAIL = "SYNCING_REJECTED_PART_LIST_FAIL"

export const SYNCING_DETAIL = "SYNCING_DETAIL"
export const SYNCING_DETAIL_FAIL = "SYNCING_DETAIL_FAIL"

export const SYNCING_ADMIN_EMAIL = "SYNCING_ADMIN_EMAIL"
export const SYNCING_ADMIN_EMAIL_UPDATE = "SYNCING_ADMIN_EMAIL_UPDATE"
export const SYNCING_ADMIN_EMAIL_FAIL = "SYNCING_ADMIN_EMAIL_FAIL"

export const SITE_NAME = "SITE_NAME"
export const SITE_NAME_FAIL = "SITE_NAME_FAIL"

export const USER_LOCATION_DETAILS_SUCCESS = 'USER_LOCATION_DETAILS_SUCCESS'
export const USER_LOCATION_DETAILS_FAILED = 'USER_LOCATION_DETAILS_FAILED'

export const COUNTRY_DATA_SUCCESS = 'COUNTRY_DATA_SUCCESS'
export const COUNTRY_DATA_ERROR = 'COUNTRY_DATA_ERROR'

export const HOLIDAY_FETCHED = "HOLIDAY_FETCHED"
export const HOLIDAY_ADDED = "HOLIDAY_ADDED"
export const HOLIDAY_UPDATED = "HOLIDAY_UPDATED"
export const HOLIDAY_DELETED = "HOLIDAY_DELETED"
export const HOLIDAY_ERROR = "HOLIDAY_ERROR"
export const HOLIDAY_UPLOAD_SUCCESS = "HOLIDAY_UPLOAD_SUCCESS"
export const HOLIDAY_UPLOAD_ERROR = "HOLIDAY_UPLOAD_ERROR"
export const STATUS_REPORT_UPLOAD_SUCCESS = "STATUS_REPORT_UPLOAD_SUCCESS"
export const STATUS_REPORT_UPLOAD_ERROR = "STATUS_REPORT_UPLOAD_ERROR"

/* PBI REPORT UPDATE */
export const PBI_REPORT_FETCH = "PBI_REPORT_FETCH"
export const PBI_REPORT_FETCH_ERROR = "PBI_REPORT_FETCH_ERROR"
export const USER_PBI_REPORTS = "USER_PBI_REPORTS"
export const PBI_REPORTS_USER_SET = "PBI_REPORTS_USER_SET"
export const PBI_REPORTS_ADMIN_USER_SET = "PBI_REPORTS_ADMIN_USER_SET"

export const PORTAL_STORYBOARD_ASSETS = "PORTAL_STORYBOARD_ASSETS"
export const PORTAL_STORYBOARD_INVENTORY_REPORT = "PORTAL_STORYBOARD_INVENTORY_REPORT"
export const PORTAL_STORYBOARD_REQUEST_SUMMARY = "PORTAL_STORYBOARD_REQUEST_SUMMARY"
export const PORTAL_STORYBOARD_SETTLEMENT_SUMMARY = "PORTAL_STORYBOARD_SETTLEMENT_SUMMARY"
export const PORTAL_STORYBOARD_FETCH_ERROR = "PORTAL_STORYBOARD_FETCH_ERROR"
export const PORTAL_STORYBOARD_PROG_BAR = "PORTAL_STORYBOARD_PROG_BAR"

export const ADD_RELEASE_NOTES_REFERENCE_FILE_SUCCESS = 'ADD_RELEASE_NOTES_REFERENCE_FILE_SUCCESS'
export const ADD_RELEASE_NOTES_REFERENCE_FILE_ERROR = 'ADD_RELEASE_NOTES_REFERENCE_FILE_ERROR'
export const GET_RELEASE_NOTES_REFERENCE_FILE_SUCCESS = 'GET_RELEASE_NOTES_REFERENCE_FILE_SUCCESS'
export const GET_RELEASE_NOTES_REFERENCE_FILE_ERROR = 'GET_RELEASE_NOTES_REFERENCE_FILE_ERROR'
export const DELETE_RELEASE_NOTES_REFERENCE_FILE_SUCCESS = 'DELETE_RELEASE_NOTES_REFERENCE_FILE_SUCCESS'
export const DELETE_RELEASE_NOTES_REFERENCE_FILE_ERROR = 'DELETE_RELEASE_NOTES_REFERENCE_FILE_ERROR'
export const PROGRAM_REQUEST_TYPES_TOTAL_LIST = 'PROGRAM_REQUEST_TYPES_TOTAL_LIST'


/* User Countries List */
export const USER_COUNTRIES_LIST = "USER_COUNTRIES_LIST"
export const ADD_USER_COUNTRIES_LIST = "ADD_USER_COUNTRIES_LIST"
export const USER_COUNTRIES_ERROR = "USER_COUNTRIES_ERROR"
export const DELETED_USER_COUNTRIES = "DELETED_USER_COUNTRIES"

/* Home Customer */
export const REQUEST_CARRIER_LABELS = "REQUEST_CARRIER_LABELS"
export const REQUEST_CARRIER_LABELS_ERROR = "REQUEST_CARRIER_LABELS_ERROR"

/* Pickup Assets */
export const PICKUP_ASSETS_LIST_SUCCESS = "PICKUP_ASSETS_LIST_SUCCESS"
export const PICKUP_ASSETS_LIST_ERROR = "PICKUP_ASSETS_LIST_ERROR"
export const SEND_CREATE_ORDER_REQUEST_SUCCESS = "SEND_CREATE_ORDER_REQUEST_SUCCESS"
export const SEND_CREATE_ORDER_REQUEST_ERROR = "SEND_CREATE_ORDER_REQUEST_ERROR"


/* Master Data Brands */
export const BRAND_ADDED_SUCCESS = "BRAND_ADDED_SUCCESS"
export const BRAND_ERROR = "BRAND_ERROR"
export const BRAND_DETAIL_SUCCESS = "BRAND_DETAIL_SUCCESS"
export const BRAND_INFO_COUNT_SUCCESS = "BRAND_INFO_COUNT_SUCCESS"
export const BRAND_UPDATED_SUCCESS = "BRAND_UPDATED_SUCCESS"
export const BRAND_DELETED_SUCCESS = "BRAND_DELETED_SUCCESS"
//Special Event Keys
export const EVENT_KEYS_SUCCESS = "EVENT_KEYS_SUCCESS"
export const EVENT_KEYS_ERROR = "EVENT_KEYS_ERROR"
export const EVENT_KEYS_ADDED_SUCCESS = "EVENT_KEYS_ADDED_SUCCESS"
export const EVENT_KEYS_ADD_ERROR = "EVENT_KEYS_ADD_ERROR"
export const EVENT_KEYS_UPDATE_SUCCESS = "EVENT_KEYS_UPDATE_SUCCESS"
export const EVENT_KEYS_DELETED_SUCCESS = "EVENT_KEYS_DELETED_SUCCESS"
export const EVENT_KEYS_COUNT_SUCCESS = "EVENT_KEYS_COUNT_SUCCESS"

export const PROGRAM_PACKAGING_SERVICES = "PROGRAM_PACKAGING_SERVICES"

/* Asset CODS */
export const GET_ASSET_CODS_LIST_SUCCESS = "GET_ASSET_CODS_LIST_SUCCESS"
export const GET_ASSET_CODS_LIST_FAILED = "GET_ASSET_CODS_LIST_FAILED"
export const POST_ASSET_COD_DATA_SUCCESS = "POST_ASSET_COD_DATA_SUCCESS"
export const POST_ASSET_COD_DATA_FAILED = "POST_ASSET_COD_DATA_FAILED"

/* Entities */

export const ENTITY_DETAIL_SUCCESS = "ENTITY_DETAIL_SUCCESS"
export const ENTITY_ADDED_SUCCESS = "ENTITY_ADDED_SUCCESS"
export const ENTITY_DELETED_SUCCESS = "ENTITY_DELETED_SUCCESS"
export const ENTITY_UPDATE_SUCCESS = "ENTITY_UPDATE_SUCCESS"
export const ENTITY_ERROR = "ENTITY_ERROR"
export const ENTITY_UPLOAD_ERROR = "ENTITY_UPLOAD_ERROR"
export const ENTITY_LIST_COUNT_SUCCESS = "ENTITY_LIST_COUNT_SUCCESS"
export const ENTITY_UPLOAD_SUCCESS = "ENTITY_UPLOAD_SUCCESS"
export const ENTITY_DETAIL_BY_COUNTRY_ID_SUCCESS = "ENTITY_DETAIL_BY_COUNTRY_ID_SUCCESS"
export const ENTITY_INFO_BY_ENTITY_ID_SUCCESS = "ENTITY_INFO_BY_ENTITY_ID_SUCCESS"


export const CARRIER_UPLOAD_SUCCESS = "CARRIER_UPLOAD_SUCCESS"
export const CARRIER_UPLOAD_ERROR = "CARRIER_UPLOAD_ERROR"
// Portal Users Bulk
export const UPLOAD_BULK_USERS = "UPLOAD_BULK_USERS"
export const BULK_USERS_ERROR = "BULK_USERS_ERROR"

export const MANUFACTURER_LIST = 'MANUFACTURER_LIST'
export const MANUFACTURER_ERROR = 'MANUFACTURER_ERROR'
export const MANUFACTURER_UPDATED_SUCCESS = "MANUFACTURER_UPDATED_SUCCESS"
export const MANUFACTURER_DETAIL_SUCCESS = "MANUFACTURER_DETAIL_SUCCESS"
export const MANUFACTURER_INFO_COUNT_SUCCESS = "MANUFACTURER_INFO_COUNT_SUCCESS"
export const LIST_ALL_MANUFACTURERS = 'LIST_ALL_MANUFACTURERS'

// B2c Portal Reception
export const TRACK_NO_DETAILS_SUCCESS = "TRACK_NO_DETAILS_SUCCESS"
export const TRACK_NO_DETAILS_ERROR = "TRACK_NO_DETAILS_ERROR"
export const PORTAL_STATUS_SUCCESS = "PORTAL_STATUS_SUCCESS"
export const PORTAL_STATUS_ERROR = "PORTAL_STATUS_ERROR"
export const ASSET_TYPE_SUCCESS = "ASSET_TYPE_SUCCESS"
export const ASSET_TYPE_ERROR = "ASSET_TYPE_ERROR"

// B2c Portal Report
export const REQUEST_DETAIL_RANGE_SUCCESS = "REQUEST_DETAIL_RANGE_SUCCESS"
export const REQUEST_DETAIL_RANGE_ERROR = "REQUEST_DETAIL_RANGE_ERROR"
export const REPORT_DOC_SUCCESS = "REPORT_DOC_SUCCESS"
export const REPORT_DOC_ERROR = "REPORT_DOC_ERROR"
export const REPORT_DOC_DELETED = "REPORT_DOC_SUCCESS"
/** Portal QR Code */
export const PORTAL_QRCODE_DATA = "PORTAL_QRCODE_DATA"
export const PORTAL_QRCODE_DATA_ADDED = "PORTAL_QRCODE_DATA_ADDED"
export const PORTAL_QRCODE_DATA_UPDATED = "PORTAL_QRCODE_DATA_UPDATED"
export const PORTAL_QRCODE_DATA_DELETED = "PORTAL_QRCODE_DATA_DELETED"
export const PORTAL_QRCODE_DATA_COUNT = "PORTAL_QRCODE_DATA_COUNT"
export const PORTAL_QRCODE_ERROR = "PORTAL_QRCODE_ERROR"

/** Power BI  */
export const PBI_DATA = 'PBI_DATA'
export const PBI_DATA_COUNT = 'PBI_DATA_COUNT'
export const PBI_DATA_ADDED = 'PBI_DATA_ADDED'
export const PBI_DATA_DELETED = 'PBI_DATA_DELETED'
export const PBI_ACCESS_DATA = 'PBI_ACCESS_DATA'
export const PBI_ACCESS_DATA_ADDED = 'PBI_ACCESS_DATA_ADDED'
export const PBI_ACCESS_DATA_DELETED = 'PBI_ACCESS_DATA_DELETED'
export const PBI_ERROR = 'PBI_ERROR'

// Models
export const MODELS_FETCHED = "MODELS_FETCHED";
export const MODEL_ERROR = "MODEL_ERROR";
export const MODEL_ADDED = "MODEL_ADDED";
export const MODEL_UPDATE = "MODEL_UPDATE";
export const MODEL_UPDATE_CANCEL = "MODEL_UPDATE_CANCEL";
export const MODEL_UPDATED = "MODEL_UPDATED";
export const MODEL_DELETED = "MODEL_DELETED";
export const MODELS_COUNTED = "MODELS_COUNTED";
export const MODEL_SET_MESSAGE = "MODEL_SET_MESSAGE";

/* Program Languages Data */
export const GET_ALL_PROGRAM_LANGUAGES_SUCCESS = 'GET_ALL_PROGRAM_LANGUAGES_SUCCESS'
export const PROGRAM_LANGUAGES_LIST_SUCCESS = 'PROGRAM_LANGUAGES_LIST_SUCCESS'
export const PROGRAM_LANGUAGES_LIST_COUNT = 'PROGRAM_LANGUAGES_LIST_COUNT'
export const PROGRAM_LANGUAGES_ERROR = 'PROGRAM_LANGUAGES_ERROR'
export const ADD_PROGRAM_LANGUAGES_DATA = 'ADD_PROGRAM_LANGUAGES_DATA'
export const DELETE_PROGRAM_LANGUAGE = 'DELETE_PROGRAM_LANGUAGE'

/* Program Packing Type Data */
export const GET_ALL_PROGRAM_PACKING_LIST_SUCCESS = 'GET_ALL_PROGRAM_PACKING_LIST_SUCCESS'
export const PROGRAM_PACKING_LIST_SUCCESS = 'PROGRAM_PACKING_LIST_SUCCESS'
export const PROGRAM_PACKING_LIST_COUNT = 'PROGRAM_PACKING_LIST_COUNT'
export const PROGRAM_PACKING_LIST_ERROR = 'PROGRAM_PACKING_LIST_ERROR'
export const ADD_PROGRAM_PACKING_LIST_DATA = 'ADD_PROGRAM_PACKING_LIST_DATA'
export const DELETE_PROGRAM_PACKING_LIST = 'DELETE_PROGRAM_PACKING_LIST'

export const PROGRAM_RECURSIVE_REQUEST = 'PROGRAM_RECURSIVE_REQUEST'
export const RECURSIVE_REQUEST_ERROR = 'RECURSIVE_REQUEST_ERROR'


/* Standard Profile */

// export const GET_STANDARD_COUNTRIES = 'GET_STANDARD_COUNTRIES'
export const CREATE_STANDARD_PROFILE_SUCCESS = 'CREATE_STANDARD_PROFILE_SUCCESS'
export const LIST_STANDARD_PROFILE_SUCCESS = 'LIST_STANDARD_PROFILE_SUCCESS'
export const COUNT_STANDARD_PROFILE_SUCCESS = 'COUNT_STANDARD_PROFILE_SUCCESS'
export const STANDARD_PROFILE_ERROR = 'STANDARD_PROFILE_ERROR'
export const STANDARD_PROFILE_DELETED_SUCCESS = 'STANDARD_PROFILE_DELETED_SUCCESS'

export const LIST_COUNTRY_PROFILE_SUCCESS = 'LIST_COUNTRY_PROFILE_SUCCESS'
export const CREATE_COUNTRY_PROFILE_SUCCESS = 'CREATE_COUNTRY_PROFILE_SUCCESS'
export const COUNTRY_PROFILE_ERROR = 'COUNTRY_PROFILE_ERROR'

export const LIST_USER_SERVICE_GROUPS_SUCCESS = 'LIST_USER_SERVICE_GROUPS_SUCCESS'
export const ADD_USER_SERVICE_GROUPS_SUCCESS = 'ADD_USER_SERVICE_GROUPS_SUCCESS'
export const DELETE_USER_SERVICE_GROUPS_SUCCESS = 'DELETE_USER_SERVICE_GROUPS_SUCCESS'
export const PORTAL_CATEGORIES_LIST_SUCCESS = 'PORTAL_CATEGORIES_LIST_SUCCESS'
export const PORTAL_CATEGORIES_ERROR = 'PORTAL_CATEGORIES_ERROR'
export const PORTAL_CATEGORIES_COUNT_SUCCESS = 'PORTAL_CATEGORIES_COUNT_SUCCESS'
// export const BOXES_DELETED_SUCCESS = 'BOXES_DELETED_SUCCESS'
// export const LIST_ALL_BOXES = 'LIST_ALL_BOXES'
// export const BOXES_ERROR = 'BOXES_ERROR'
// export const BOXES_UPDATED_SUCCESS = "BOXES_UPDATED_SUCCESS"
// export const BOX_INFO_COUNT_SUCCESS = "BOX_INFO_COUNT_SUCCESS"
